import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconQuestionmarkCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconQuestionmarkCircle"><Circle cx="12" cy="12" r="9.5" stroke="currentColor"/><Path d="M12 14.5C12 11 14.5 11.5267 14.5 9.22617C14.5 6.2796 9.5 6.11013 9.5 9.60998" stroke="currentColor" strokeLinejoin="round"/><Circle cx="12" cy="16.75" r="0.75" fill="currentColor"/></CentralIconBase>;
});

export default IconQuestionmarkCircle;
